import { v4 as uuidv4 } from 'uuid';

const DEVICE_ID_KEY = 'device:id';

const getOrCreateDeviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = uuidv4();
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch {
    return uuidv4();
  }
};

export const getDeviceId = () => Promise.resolve(getOrCreateDeviceId());

export const getAppVersion = () =>
  Promise.resolve(typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null);
